// Chip «Crédito» / «Contado»: si SureKeep financia el producto o va solo de contado.
import { cn } from '@/lib/cn';

export function FinancingBadge({
    financeable,
    className,
}: {
    financeable: boolean;
    className?: string;
}) {
    const label = financeable ? 'Crédito' : 'Contado';
    const title = financeable ? 'Financiable con SureKeep' : 'Solo de contado';
    return (
        <span
            title={title}
            className={cn(
                'inline-flex min-w-0 items-center truncate rounded-full border px-2 py-0.5 text-[10px] font-medium leading-[1.35]',
                financeable
                    ? 'border-success-soft-border bg-success-soft text-success'
                    : 'border-border bg-muted text-muted-foreground',
                className,
            )}
        >
            {label}
        </span>
    );
}
